// Components==============
import React from 'react';
import './Video.module.scss';
// @ts-ignore
import Plyr from 'faqta-react-plyr';
import { getVideoData } from 'utilities/getVideoData';
// =========================

function VideoPlayer({ link }: { link: string }) {
  const { videoType, videoId, videoControls } = getVideoData(link);

  return (
    <div styleName="video-player">
      <div styleName="video">
        <Plyr
          type={videoType}
          videoId={videoId}
          fullscreen={{
            enabled: true,
            fallback: true,
            iosNative: true,
          }}
          controls={videoControls}
        />
      </div>
    </div>
  );
}

export default function Video({ link }: { link: string }) {
  return <VideoPlayer link={link} />;
}
